import { render } from "./StaticMap.vue?vue&type=template&id=7fd85f15"
import script from "./StaticMap.vue?vue&type=script&lang=js"
export * from "./StaticMap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__